import { defineStore, acceptHMRUpdate } from 'pinia';
import { apiClient } from '@/api/client';
import { useToast } from 'vue-toastification';
import socket from '@/socket';

const toast = useToast();
const useTpaStore = defineStore({
    id: 'aboutus',
    state: () => ({
        eggDescList: [
            {
                eggBackgroundObj: { componentName: 'tpa', imgName: 'benefit1', imgFormat: 'png' },
                label: 'tpa.tpaBenefitDesc1'
            },
            {
                eggBackgroundObj: { componentName: 'tpa', imgName: 'benefit2', imgFormat: 'png' },
                label: 'tpa.tpaBenefitDesc2'
            },
            {
                eggBackgroundObj: { componentName: 'tpa', imgName: 'benefit3', imgFormat: 'png' },
                label: 'tpa.tpaBenefitDesc3'
            }
        ],
        adultDescList: [
            "tpa.tpaOssDesc1",
            "tpa.tpaOssDesc2",
            "tpa.tpaOssDesc3",
            "tpa.tpaOssDesc4",
            "tpa.tpaOssDesc5",
            "tpa.tpaOssDesc6",
            "tpa.tpaOssDesc7",
            "tpa.tpaOssDesc8",
            "tpa.tpaOssDesc9",
            "tpa.tpaOssDesc10"
        ]
    }),
    getters: {},
    actions: {
    },

});
// make sure to pass the right store definition
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTpaStore, import.meta.hot));
}

export { useTpaStore };